const formatNumber = number => {
  if (number === null || typeof number === 'undefined') {
    number = 0;
  }

  if (typeof number === 'string') {
    number = parseFloat(number);
  }

  if (isNaN(number)) {
    number = 0;
  }

  let formattedNumber = number.toFixed(2);
  formattedNumber = formattedNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return formattedNumber;
};

export default formatNumber;
